import { render, staticRenderFns } from "./NewPrivacyAuditDialog.vue?vue&type=template&id=e13173dc&"
import script from "./NewPrivacyAuditDialog.vue?vue&type=script&lang=js&"
export * from "./NewPrivacyAuditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewPrivacyAuditDialog.vue"
export default component.exports